import React from "react";
import {
  Button,
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  ButtonGroup,
  makeStyles,
} from "@material-ui/core";
import { formatDinero } from "./../../../utils/formatDinero";
import { useDispatch } from "react-redux";
import { eliminarExtraPaqueteAction, obtenerExtrasByIdPaqueteAction } from "../../../ducks/extrasDuck";
import Swal from "sweetalert2";
import { ToastMessage } from "../../../global/ToastMessage";
import { DialogMessage } from "../../../global/DialogMessage";
import DialogDescripcion from "./DialogDescipcion";
import DeleteIcon from '@material-ui/icons/Delete';
import FTipoExtra from "./FTipoExtra";
import ActualizaExtra from "./ActulizaExtra";
import DialogTipoExtra from "./DialogTipoExtra";

const useStyles = makeStyles({
  root: {
    width: '100%'
  },
  container: {
    maxHeight: 350,
  },
})

const TablaRegistro = (props) => {
  const { rows = [], idPaquete = 0, Moneda = "" } = props;
  const dispatch = useDispatch();
  const classes = useStyles();
  const onDelete = (row) => {
    DialogMessage.fire({
      title: '¿Estas seguro?',
      text: "¡No podrás revertir esto!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '¡Eliminarlo!',
      cancelButtonText: '¡Cancelar!',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(eliminarExtraPaqueteAction(idPaquete, row.Extra.IdExtra)).then(Response => {
          dispatch(obtenerExtrasByIdPaqueteAction(idPaquete));
          ToastMessage.fire(
            '¡Elimminado!',
            '¡El extra ha sido eliminada!',
            'success'
          )
        })
      } else if (
        /* Read more about handling dismissals below */
        result.dismiss === Swal.DismissReason.cancel
      ) {
        ToastMessage.fire(
          'Cancelado',
          'No se ha realizado ningun cambio',
          'info'
        )
      }
    })
  }
  return (
    <TableContainer component={Paper} className={classes.container}>
      <Table size="small" stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow>
            <TableCell align="center">Extra</TableCell>
            <TableCell align="center">Origen</TableCell>
            <TableCell align="center">Suplemento</TableCell>
            <TableCell align="center">Tipo</TableCell>
            <TableCell align="center">Descripción</TableCell>
            <TableCell align="center"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={row.Extra?.IdExtra}>
              <TableCell align="center">{row.Extra?.Nombre}</TableCell>
              <TableCell align="center">{`${row.Extra?.Origen?.Nombre}`}</TableCell>
              <TableCell align="center">{formatDinero(row.Suplemento)}</TableCell>
              <TableCell align="center">
                {
                  (row.CatExtra?.idCatExtra > 0) ?
                    <div>{row.CatExtra?.Descripcion} <DialogTipoExtra TipoExtra={row.CatExtra?.Descripcion} idExtra={row.Extra?.IdExtra} /></div>
                    : <span>Sin Asignar</span>
                }
              </TableCell>
              <TableCell align="center">
                <DialogDescripcion Descripcion={row.Extra?.Descripcion} />
              </TableCell>
              <TableCell align="center">
                <ButtonGroup
                  color="primary"
                  size="small"
                  aria-label="small outlined  button group"
                >
                  <FTipoExtra
                    idExtra={row.Extra?.IdExtra}
                    Nombre={row.Extra?.Nombre}
                    idPaquete={idPaquete}
                  />
                  <ActualizaExtra
                    idExtra={row.Extra?.IdExtra}
                    Nombre={row.Extra?.Nombre}
                    idPaquete={idPaquete}
                    Precio={row.Suplemento}
                    Descripcion={row.Extra?.Descripcion}
                    Moneda={Moneda}
                  />
                  <Button onClick={() => onDelete(row)}>
                    <DeleteIcon />
                  </Button>
                </ButtonGroup>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
export default TablaRegistro;
